{
  "de": {
    "subscriptions": {
      "plans": {
        "free": {
          "title": "Kostenfreies Konto"
        },
        "courses": {
          "title": "Fortbildungs-Flatrate",
          "subtitle": "Voller Zugriff auf alle fobizz Fortbildungsangebote.",
          "features": "<li><i class='bi bi-check-lg'></i><div>Zugriff auf den gesamten Fortbildungskatalog</div></li><li><i class='bi bi-check-lg'></i><div>Zugang zu allen Webinar-Aufzeichnungen</div></li><li><i class='bi bi-check-lg'></i><div>Praxisnahe Übungen und Materialien inkludiert</div></li><li><i class='bi bi-check-lg'></i><div>Alle Fortbildungen mit Zertifikat</div></li>"
        },
        "tools": {
          "title": "Tools-Flatrate",
          "subtitle": "Unbegrenzter Zugriff auf fobizz Tools und KI-Assistenz für den Unterricht.",
          "features": "<li><i class='bi bi-check-lg'></i><div>Unlimitierte Nutzung aller digitalen Tools</div></li><li><i class='bi bi-check-lg'></i><div>Unlimitierter Zugang zu KI Klassenräumen</div></li><li><i class='bi bi-check-lg'></i><div>Unlimitierte Erstellung eigener KI Assistenten und Chatbots</div></li><li><i class='bi bi-check-lg'></i><div>Keine Registrierung von Schüler*innen notwendig</div></li>"
        },
        "combined": {
          "title": "Kombi-Flatrate",
          "subtitle": "Voller Zugriff auf alle Fortbildungsangebote, Tools und KI-Assistenz.",
          "badge": "Beliebt",
          "features": "<li><i class='bi bi-check-lg'></i><div>Alle Vorteile der Fortbildungs- und Tools-Lizenz</div></li><li><i class='bi bi-check-lg'></i><div>Spare 25% gegenüber dem Einzelpreis</div></li><li><i class='bi bi-check-lg'></i><div>Zugriff auf den gesamten Fortbildungskatalog</div></li><li><i class='bi bi-check-lg'></i><div>Unlimitierte Nutzung aller digitalen Tools inkl. KI</div></li>"
        },
        "pricing_card": {
          "year": "Jahr",
          "month": "Monat",
          "buy_now": "Jetzt kaufen",
          "checkout_error": "Beim Öffnen des Checkouts ist ein Fehler aufgetreten. Bitte versuche es später erneut."
        }
      }
    }
  }
}
